module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-xs-12 col-md-8 col-lg-9 principal"
  }, [_vm._t("breadcrumb"), _vm._t("principal")], 2), _c('div', {
    staticClass: "col-md-4 col-lg-3 visible-md visible-lg lateral"
  }, [_vm._t("lateral")], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 timbre_impressao"
  }, [_c('img', {
    attrs: {
      "src": "static/logo_mobile.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5c00762","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Pagina.vue
// module id = 514
// module chunks = 0